// @ts-ignore
import { Noise } from "noisejs";

export abstract class Simulation {
  public instance: any;
  protected noiseGenerator: any;

  constructor() {
    this.noiseGenerator = new Noise(Math.random());
  }

  protected abstract setup(): void;
  public abstract run(): void;
}
